import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';
import SocialEntryConfiguration from 'entity/SocialEntryConfiguration';
import SocialRoomSet from 'entity/SocialRoomSet';
@Component({
  selector: 'entry-flow-preview',
  templateUrl: './entry-flow-preview.component.html',
  styleUrls: ['./entry-flow-preview.component.scss'],
  standalone: false,
})
export class EntryFlowPreviewComponent extends Loggable implements OnDestroy, OnInit {
  private destroyed$ = new ReplaySubject<boolean>(1);

  @Input() public previewInfo?: SocialEntryConfiguration;
  @Input() public appliedRoomsName?: string[];
  @Input() public scootaverse?: SocialRoomSet;
  @Input() public isEdit?: boolean;
  @Output() public saveEntryFlowClick = new EventEmitter<boolean>();

  public constructor() {
    super();
    this.setDisplayName('EntryFlowPreviewComponent');
  }

  public ngOnInit(): void {
    this.info('init');
  }

  public saveFlow() {
    this.saveEntryFlowClick.emit(true);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
